import { useContext } from "react";
import FeatureFlagContext from "./context";
import type { FlagRecord } from "./flags";

const useFeatureFlags = () => useContext<FlagRecord>(FeatureFlagContext);

export default useFeatureFlags;
